export default __webpack_public_path__ + "static/media/portfolio.528b5ada.jpg";